export const FEATURE_FLAG_PROMOTE_REGIME_ID = "promote-scenario-regime"
export const FEATURE_FLAG_PROMOTE_REGIME_DEMAND = `feature-${FEATURE_FLAG_PROMOTE_REGIME_ID}`
